import { fireLinkTag } from '~/features/analytics/tagManager';

export function reviewTopLinkTag() {
  fireLinkTag({ event_name: 'read_reviews', link_name: 'read_reviews' });
}

export function writeReviewTopLinkTag() {
  fireLinkTag({ event_name: 'write_a_review-top', link_name: 'write_a_review-top' });
}
